<template>
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 2.33354L7 11.6669" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11.0834 7.58354L7.00004 11.6669L2.91671 7.58354" stroke="white" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round"/>
</svg>
</template>
